import { render, staticRenderFns } from "./category.vue?vue&type=template&id=317c3a24"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=317c3a24&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317c3a24')) {
      api.createRecord('317c3a24', component.options)
    } else {
      api.reload('317c3a24', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=317c3a24", function () {
      api.rerender('317c3a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/categorylist/category.vue"
export default component.exports